<div class="container">
  <div class="px-6 py-4 border-b flex items-center header-title">
    <h2 class="title m-0">{{"CHALLENGE-TIME.NEW-WEEK" | translate}}</h2>
  </div>
  <div class="card p-2">
    <div class="form-row">
      <mat-form-field appearance="fill">
        <mat-label>{{"CHALLENGE-TIME.WEEK" | translate}}</mat-label>
        <input matInput [(ngModel)]="week" readonly>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>{{"CHALLENGE-TIME.PUBLISH" | translate}}</mat-label>
        <input matInput [matDatepicker]="picker" [(ngModel)]="publishAt" required>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="weeks">
      <div class="d-flex">
        <h3>Video</h3>
        <button mat-raised-button (click)="newVideo = true" class="bottone-viola" *ngIf="!newVideo">
          {{editingVideo !== null ? 'Modifica video' : 'Aggiungi video'}}
        </button>
        <span *ngIf="newVideo && editingVideo === null">
          <button mat-raised-button (click)="cancelAddVideo()" class="bottone-rosso" *ngIf="newVideo">
            {{"GLOBAL.CANCEL" | translate}}
          </button>
          <button mat-raised-button (click)="addVideo()" class="bottone-viola" [disabled]="!isVideoToAddValid()" *ngIf="newVideo">
            {{"GLOBAL.CONFIRM" | translate}}
          </button>
        </span>
        <span *ngIf="newVideo && editingVideo !== null">
          <button mat-raised-button (click)="cancelAddVideo()" class="bottone-rosso" *ngIf="newVideo">
            {{"GLOBAL.CANCEL" | translate}}
          </button>
          <button mat-raised-button (click)="confirmEditVideo()" class="bottone-viola" [disabled]="!isVideoToAddValid()" *ngIf="newVideo">
            {{"GLOBAL.EDIT" | translate}}
          </button>
        </span>
      </div>
      <span *ngIf="!newVideo">
        <div class="full-card" *ngFor="let video of videos; let indice = index">
          <div>
            <div class="top-card">
              <h1>{{video.i18nTitle[translate.currentLang.toUpperCase()]}}</h1>
              <mat-icon svgIcon="mat:edit" (click)="editVideo(indice)"></mat-icon>
              <mat-icon svgIcon="mat:delete" (click)="deleteVideo(indice)"></mat-icon>
            </div>
            <div class="main-card">
              <p>{{video.i18nDescription[translate.currentLang.toUpperCase()]}}</p>
            </div>
          </div>

          <div class="action-card">
            <img src="https://play.vidyard.com/{{video.videoId[translate.currentLang.toUpperCase()]}}.jpg" alt="">
            <div class="arrow-icons-zone">
              <span class="icon-card" (click)="moveVideo('up', indice)" *ngIf="indice > 0">
                <mat-icon svgIcon="mat:expand_less"></mat-icon>
              </span>
              <span class="icon-card disabled" *ngIf="indice === 0">
                <mat-icon svgIcon="mat:expand_less"></mat-icon>
              </span>
              <span class="icon-card disabled" *ngIf="videos.length-1 === indice">
                <mat-icon svgIcon="mat:expand_more"></mat-icon>
              </span>
              <span class="icon-card" (click)="moveVideo('down', indice)" *ngIf="videos.length-1 > indice">
                <mat-icon svgIcon="mat:expand_more"></mat-icon>
              </span>
            </div>
          </div>
        </div>
      </span>
      <span *ngIf="newVideo">
        <div class="px-6 py-4 border-b flex items-center header-title">
          <h2 class="title m-0">{{"CHALLENGE-TIME.ADD" | translate}} video</h2>
        </div>
        <div class="form-row">
          <mat-form-field appearance="fill">
            <mat-label>{{"CHALLENGE-TIME.NAME" | translate}} video {{"GLOBAL.ITA" | translate}}</mat-label>
            <input matInput [(ngModel)]="videoToAdd.i18nTitle['IT']" required>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>{{"CHALLENGE-TIME.NAME" | translate}} video {{"GLOBAL.ENG" | translate}}</mat-label>
            <input matInput [(ngModel)]="videoToAdd.i18nTitle['EN']" required>
          </mat-form-field>
        </div>
        <div class="form-row">
          <mat-form-field appearance="fill">
            <mat-label>Pdf {{"GLOBAL.ITA" | translate}}</mat-label>
            <input matInput [(ngModel)]="videoToAdd.pdf['IT']">
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Pdf {{"GLOBAL.ENG" | translate}}</mat-label>
            <input matInput [(ngModel)]="videoToAdd.pdf['EN']">
          </mat-form-field>
        </div>
        <div class="form-row">
          <mat-form-field appearance="fill">
            <mat-label>Video UUID {{"GLOBAL.ITA" | translate}}</mat-label>
            <input matInput [(ngModel)]="videoToAdd.videoId['IT']" required>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Video UUID {{"GLOBAL.ENG" | translate}}</mat-label>
            <input matInput [(ngModel)]="videoToAdd.videoId['EN']" required>
          </mat-form-field>
        </div>
        <div class="form-row">
          <mat-form-field appearance="fill">
            <mat-label>{{"CHALLENGE-TIME.DESC" | translate}} {{"GLOBAL.ITA" | translate}}</mat-label>
            <textarea cols="30" rows="4" matInput [(ngModel)]="videoToAdd.i18nDescription['IT']" required></textarea>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>{{"CHALLENGE-TIME.DESC" | translate}} {{"GLOBAL.ENG" | translate}}</mat-label>
            <textarea cols="30" rows="4" matInput [(ngModel)]="videoToAdd.i18nDescription['EN']" required></textarea>
          </mat-form-field>
        </div>
      </span>
    </div>
    <div class="bottoni">
      <button (click)="confirmClose()" mat-button-base class="m-4">{{"GLOBAL.CLOSE" | translate}}</button>
      <button mat-raised-button [disabled]="!publishAt" (click)="submit()" class="m-4 bottone-viola">
        {{"GLOBAL.CREATE" | translate}}
      </button>
    </div>
  </div>
</div>
